import ClosedOrders from "./ClosedOrders";

export default ClosedOrders;
